// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import baseTheme from "@insite/mobius/globals/baseTheme";
import GridItem from "@insite/mobius/GridItem";
import { css } from "styled-components";

// This code is workaround the OOTB code to fix a bug in grid offset width calculation.
GridItem.defaultProps = {
    ...GridItem.defaultProps,
    css: css`
        ${({ theme, gap }: any) => {
            if (gap > 0) {
                const { maxWidths, paddingValues } = theme.breakpoints || baseTheme.breakpoints;
                const maxWidth = maxWidths[maxWidths.length - 1];
                const padding = paddingValues ? paddingValues[paddingValues.length - 1] : 15;
                const paddingsSum = 2 * padding;
                return css`
                    @media (max-width: ${maxWidth + gap}px) {
                        padding: ${(gap as number) > paddingsSum ? `${padding}px` : `${gap / 2}px`};
                    }
                `;
            }
            return null;
        }}
    `,
};
